import { default as indexelPorSShqQMeta } from "/home/runner/work/trueblue-web/trueblue-web/pages/about-us/index.vue?macro=true";
import { default as indexZGBNEqISccMeta } from "/home/runner/work/trueblue-web/trueblue-web/pages/create/index.vue?macro=true";
import { default as indextxAUK1PtHxMeta } from "/home/runner/work/trueblue-web/trueblue-web/pages/FAQ/index.vue?macro=true";
import { default as index4lLbh0CpbpMeta } from "/home/runner/work/trueblue-web/trueblue-web/pages/fresh/index.vue?macro=true";
import { default as indexWSSNt0CdDQMeta } from "/home/runner/work/trueblue-web/trueblue-web/pages/index.vue?macro=true";
import { default as indexhHdqDRIvlNMeta } from "/home/runner/work/trueblue-web/trueblue-web/pages/login/index.vue?macro=true";
import { default as _91id_93ePK8u8P4QrMeta } from "/home/runner/work/trueblue-web/trueblue-web/pages/payment/pay/[id].vue?macro=true";
import { default as indexa6CcW9tt2wMeta } from "/home/runner/work/trueblue-web/trueblue-web/pages/payment/success/index.vue?macro=true";
import { default as indexHRb8Iyb0SsMeta } from "/home/runner/work/trueblue-web/trueblue-web/pages/profile/my-addresses/index.vue?macro=true";
import { default as edit62W3yBHGVdMeta } from "/home/runner/work/trueblue-web/trueblue-web/pages/profile/my-deliveries/[id]/edit.vue?macro=true";
import { default as indexxTPT1cNU4cMeta } from "/home/runner/work/trueblue-web/trueblue-web/pages/profile/my-deliveries/[id]/index.vue?macro=true";
import { default as indexj4NWshAvILMeta } from "/home/runner/work/trueblue-web/trueblue-web/pages/profile/my-deliveries/index.vue?macro=true";
import { default as my_45payment_45methodsQTZ4EO1AjvMeta } from "/home/runner/work/trueblue-web/trueblue-web/pages/profile/my-payment-methods.vue?macro=true";
import { default as my_45pets4JuSovggAyMeta } from "/home/runner/work/trueblue-web/trueblue-web/pages/profile/my-pets.vue?macro=true";
import { default as indexB5qdAAAmq0Meta } from "/home/runner/work/trueblue-web/trueblue-web/pages/profile/my-plan/[id]/index.vue?macro=true";
import { default as indexuRG2XjguLnMeta } from "/home/runner/work/trueblue-web/trueblue-web/pages/profile/my-plan/index.vue?macro=true";
import { default as editfLO3Sr1HeLMeta } from "/home/runner/work/trueblue-web/trueblue-web/pages/profile/my-profile/edit.vue?macro=true";
import { default as indexCWvbuwucZoMeta } from "/home/runner/work/trueblue-web/trueblue-web/pages/profile/my-profile/index.vue?macro=true";
import { default as createkBrdYl8cxMMeta } from "/home/runner/work/trueblue-web/trueblue-web/pages/profile/my-profile/pets/create.vue?macro=true";
import { default as my_45profileZDiMzLuHv2Meta } from "/home/runner/work/trueblue-web/trueblue-web/pages/profile/my-profile.vue?macro=true";
import { default as my_45recommendedsY5PEs4jPBfMeta } from "/home/runner/work/trueblue-web/trueblue-web/pages/profile/my-recommendeds.vue?macro=true";
import { default as my_45referalsXrm4LXA9YdMeta } from "/home/runner/work/trueblue-web/trueblue-web/pages/profile/my-referals.vue?macro=true";
import { default as profileqyyfBJFwDZMeta } from "/home/runner/work/trueblue-web/trueblue-web/pages/profile.vue?macro=true";
import { default as index6ydXmRziVxMeta } from "/home/runner/work/trueblue-web/trueblue-web/pages/recipes/[id]/index.vue?macro=true";
import { default as index9TWhSao2NUMeta } from "/home/runner/work/trueblue-web/trueblue-web/pages/recipes/index.vue?macro=true";
import { default as indexmqCgcO9sxnMeta } from "/home/runner/work/trueblue-web/trueblue-web/pages/registry/index.vue?macro=true";
import { default as index2BvVLnpQByMeta } from "/home/runner/work/trueblue-web/trueblue-web/pages/vets/index.vue?macro=true";
export default [
  {
    name: "about-us___es",
    path: "/about-us",
    component: () => import("/home/runner/work/trueblue-web/trueblue-web/pages/about-us/index.vue")
  },
  {
    name: "create___es",
    path: "/create",
    meta: indexZGBNEqISccMeta || {},
    component: () => import("/home/runner/work/trueblue-web/trueblue-web/pages/create/index.vue")
  },
  {
    name: "FAQ___es",
    path: "/FAQ",
    component: () => import("/home/runner/work/trueblue-web/trueblue-web/pages/FAQ/index.vue")
  },
  {
    name: "fresh___es",
    path: "/fresh",
    component: () => import("/home/runner/work/trueblue-web/trueblue-web/pages/fresh/index.vue")
  },
  {
    name: "index___es",
    path: "/",
    component: () => import("/home/runner/work/trueblue-web/trueblue-web/pages/index.vue")
  },
  {
    name: "login___es",
    path: "/login",
    component: () => import("/home/runner/work/trueblue-web/trueblue-web/pages/login/index.vue")
  },
  {
    name: "payment-pay-id___es",
    path: "/payment/pay/:id()",
    meta: _91id_93ePK8u8P4QrMeta || {},
    component: () => import("/home/runner/work/trueblue-web/trueblue-web/pages/payment/pay/[id].vue")
  },
  {
    name: "payment-success___es",
    path: "/payment/success",
    meta: indexa6CcW9tt2wMeta || {},
    component: () => import("/home/runner/work/trueblue-web/trueblue-web/pages/payment/success/index.vue")
  },
  {
    name: "profile___es",
    path: "/profile",
    component: () => import("/home/runner/work/trueblue-web/trueblue-web/pages/profile.vue"),
    children: [
  {
    name: "profile-my-addresses___es",
    path: "my-addresses",
    component: () => import("/home/runner/work/trueblue-web/trueblue-web/pages/profile/my-addresses/index.vue")
  },
  {
    name: "profile-my-deliveries-id-edit___es",
    path: "my-deliveries/:id()/edit",
    component: () => import("/home/runner/work/trueblue-web/trueblue-web/pages/profile/my-deliveries/[id]/edit.vue")
  },
  {
    name: "profile-my-deliveries-id___es",
    path: "my-deliveries/:id()",
    component: () => import("/home/runner/work/trueblue-web/trueblue-web/pages/profile/my-deliveries/[id]/index.vue")
  },
  {
    name: "profile-my-deliveries___es",
    path: "my-deliveries",
    component: () => import("/home/runner/work/trueblue-web/trueblue-web/pages/profile/my-deliveries/index.vue")
  },
  {
    name: "profile-my-payment-methods___es",
    path: "my-payment-methods",
    component: () => import("/home/runner/work/trueblue-web/trueblue-web/pages/profile/my-payment-methods.vue")
  },
  {
    name: "profile-my-pets___es",
    path: "my-pets",
    component: () => import("/home/runner/work/trueblue-web/trueblue-web/pages/profile/my-pets.vue")
  },
  {
    name: "profile-my-plan-id___es",
    path: "my-plan/:id()",
    component: () => import("/home/runner/work/trueblue-web/trueblue-web/pages/profile/my-plan/[id]/index.vue")
  },
  {
    name: "profile-my-plan___es",
    path: "my-plan",
    component: () => import("/home/runner/work/trueblue-web/trueblue-web/pages/profile/my-plan/index.vue")
  },
  {
    name: my_45profileZDiMzLuHv2Meta?.name,
    path: "my-profile",
    component: () => import("/home/runner/work/trueblue-web/trueblue-web/pages/profile/my-profile.vue"),
    children: [
  {
    name: "profile-my-profile-edit___es",
    path: "edit",
    component: () => import("/home/runner/work/trueblue-web/trueblue-web/pages/profile/my-profile/edit.vue")
  },
  {
    name: "profile-my-profile___es",
    path: "",
    component: () => import("/home/runner/work/trueblue-web/trueblue-web/pages/profile/my-profile/index.vue")
  },
  {
    name: "profile-my-profile-pets-create___es",
    path: "pets/create",
    component: () => import("/home/runner/work/trueblue-web/trueblue-web/pages/profile/my-profile/pets/create.vue")
  }
]
  },
  {
    name: "profile-my-recommendeds___es",
    path: "my-recommendeds",
    component: () => import("/home/runner/work/trueblue-web/trueblue-web/pages/profile/my-recommendeds.vue")
  },
  {
    name: "profile-my-referals___es",
    path: "my-referals",
    component: () => import("/home/runner/work/trueblue-web/trueblue-web/pages/profile/my-referals.vue")
  }
]
  },
  {
    name: "recipes-id___es",
    path: "/recipes/:id()",
    component: () => import("/home/runner/work/trueblue-web/trueblue-web/pages/recipes/[id]/index.vue")
  },
  {
    name: "recipes___es",
    path: "/recipes",
    component: () => import("/home/runner/work/trueblue-web/trueblue-web/pages/recipes/index.vue")
  },
  {
    name: "registry___es",
    path: "/registry",
    meta: indexmqCgcO9sxnMeta || {},
    component: () => import("/home/runner/work/trueblue-web/trueblue-web/pages/registry/index.vue")
  },
  {
    name: "vets___es",
    path: "/vets",
    component: () => import("/home/runner/work/trueblue-web/trueblue-web/pages/vets/index.vue")
  }
]